// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + "product" + "." + "70aeacf5" + ".css"; };